import React, { useState, useEffect } from 'react';
import { useLocation } from "@tanstack/react-router";
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import CaseStudiesSection from './CaseStudiesSection';
import ShowcaseSection from './ShowcaseSection';
import TestimonialsSection from './TestimonialsSection';
import LeadGenerationSection from './LeadGenerationSection';
import StatsSection from './StatsSection';
import Footer from './Footer';
import EyeOrangeLanding from './eyeOrange/EyeOrangeLanding';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      if (pathname === '/about') {
        const element = document.getElementById('about');
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      } else if (pathname === '/contact') {
        const element = document.getElementById('contact');
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [isLoading, pathname]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-black to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 border-4 border-gray-600 border-t-silver rounded-full animate-spin"></div>
          <p className="text-silver text-lg font-mono">Loading Excellence...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-silver">
      <Navigation />
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      <CaseStudiesSection />
      <ShowcaseSection />
      <TestimonialsSection />
      <LeadGenerationSection />
      <Footer />
      {/* <EyeOrangeLanding/> */}
    </div>
  );
};

export default HomePage;